
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/english_legacy",
      function () {
        return require("private-next-pages/english_legacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/english_legacy"])
      });
    }
  